import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import {SessionService} from "../../services/session.service"; import {ActivatedRoute} from "@angular/router";
import {isBooleanLiteralLike} from "codelyzer/util/utils";

@Directive({
	selector: '[appUserRole]'
})
export class UserRoleDirective implements OnInit {

	@Input() appUserRole: string | string[];

	constructor(
		private templateRef: TemplateRef<any>,
		private viewContainer: ViewContainerRef,
		private sessionService: SessionService
	) { }

	ngOnInit() {
		if(!this.sessionService.userType) {
			this.viewContainer.clear();
		} else if (this.sessionService.userType && this.sessionService.permissions.length > 0) {
			if (Array.isArray(this.appUserRole)) {
				for (let role of this.appUserRole) {
					if (this.checkIfPermissionExists(this.sessionService.permissions, role)) {
						this.viewContainer.createEmbeddedView(this.templateRef);
						return;
					} else {
						console.log('false');
					}
				}
			} else {
				if (this.checkIfPermissionExists(this.sessionService.permissions, this.appUserRole)) {
					this.viewContainer.createEmbeddedView(this.templateRef);
					return;
				}
			}
			this.viewContainer.clear();
		} else {
			this.viewContainer.clear();
		}
	}

	/**
	 * Check if user has permission for the component functionality
	 */
	checkIfPermissionExists(permissions: Array<object>, functionality: string): boolean {
		const index = permissions.findIndex(permission => permission['name'] === functionality);
		return index === -1 ? false : true;
	}
}
